import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _isNil from 'lodash/isNil';
import PropTypes from 'prop-types';
// Models
import mDevice from 'models/device';
// Custom
import { deviceDataShape } from 'constants/PropTypesShapes';
import InformationItem from 'components/items/InformationItem';

const DeviceStatusItem = ({ device, light, ...props }) => {
  const status = mDevice.status(device);

  return (
    <InformationItem
      light={light}
      icon={status.icon}
      iconColor={status.color}
      label={<LocalizedMessage id="field.status" />}
      value={(device && !_isNil(device.timeout)) ? <LocalizedMessage id={`device.timeout.${device.timeout}`} /> : null}
      gender="male"
      {...props}
    />
  );
};

DeviceStatusItem.propTypes = {
  device: deviceDataShape,
  light: PropTypes.bool,
};

DeviceStatusItem.defaultProps = {
  device: null,
  light: false,
};

module.exports = DeviceStatusItem;



// WEBPACK FOOTER //
// ./routes/app/routes/devices/assets/main/DeviceStatusItem.js